import classNames from '@prague-digi/class-names'
import get from 'lodash/get'
import React from 'react'
import set from 'lodash/set'

import { ModalDialog } from '../../../../components'
import {
  ModalDialogConfiguration,
  ModalDialogSeverityEnum,
} from '../../../../redux/reducers/modalDialog/model'

import styles from './styles.scss'

interface Props {
  children: any | any[]
  onClose: Function
}

interface State {
  actualStepNumber: number
  child: any
  children: any | any[]
  show: boolean
  stepCount: number
}

export class ModalWizard extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    let stepCount = 1
    let child = props.children
    if (Array.isArray(props.children)) {
      stepCount = props.children.length
      child = props.children[0]
    }

    this.state = {
      show: true,
      children: props.children,
      child,
      stepCount,
      actualStepNumber: 0,
    }

    this.documentBodyOverflowBackup = get(document, 'body.style.overflow')
    set(document, 'body.style.overflow', 'hidden')
  }

  componentWillUnmount(): void {
    set(document, 'body.style.overflow', this.documentBodyOverflowBackup)
  }

  onContinue = () => {
    if (this.state.actualStepNumber < this.state.stepCount - 1) {
      const index = this.state.actualStepNumber + 1
      this.setState({
        child: this.state.children[index],
        actualStepNumber: index,
      })
    } else {
      this.setState(
        {
          show: false,
        },
        () => {
          setTimeout(() => {
            this.props.onClose()
          }, 300)
        }
      )
    }
  }

  onClose = () => {
    this.setState(
      {
        show: false,
      },
      () => {
        setTimeout(() => {
          this.props.onClose()
        }, 300)
      }
    )
  }

  documentBodyOverflowBackup: any = null

  render() {
    const stepper = []

    for (let i = 0; i < this.state.stepCount; i++) {
      stepper.push(
        <div
          className={classNames(styles.stepperItem, {
            [styles.active]: i === this.state.actualStepNumber,
          })}
          key={i}>
          {i + 1}
        </div>
      )

      if (i !== this.state.stepCount - 1) {
        stepper.push(<div className={styles.stepperDelimiter} key={`delimiter_${i}`} />)
      }
    }

    const content = (
      <>
        {this.state.stepCount > 1 && <div className={styles.stepper}>{stepper}</div>}
        <div className={styles.content}>
          {React.cloneElement(this.state.child, {
            isModal: true,
            onClose: this.state.actualStepNumber === 0 ? this.onClose : undefined,
            onContinue: this.onContinue,
          })}
        </div>
      </>
    )

    const modalOptions: ModalDialogConfiguration = {
      closeButton: {},
      content,
      id: 'WIZARD',
      severity: ModalDialogSeverityEnum.Hint,
      noFooter: true,
      preferredWidth: '700px',
      secondButton: {},
      show: this.state.show,
    }

    return <ModalDialog {...modalOptions} />
  }
}

export default ModalWizard
